import React from "react";

export function Rule ({name = () => "n/a", status = () => "n/a", id=()=> "n/a"}){
    return(<div>
        [{id}]{name} {status}
    </div>);
}